import React from 'react';
import PropertytypeBuildingOutline from './propertytype_building_outline';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function BuildingIcon(props) {
  return ___EmotionJSX(PropertytypeBuildingOutline, props);
}